import { __assign, __read } from "tslib";
import React, { useRef, useState, useContext, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { PieLabel } from '../../components';
import { StyledPath } from './pie-slice.styles';
import { getActiveKeyVariants } from './utils';
import { createArcTween, animateArcPath, } from '../circular-chart';
import { ChartContext } from '../../contexts';
var sliceTransition = { duration: 0.2, ease: 'easeInOut' };
var sliceVariants = {
    hidden: { opacity: 0 },
    remove: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            ease: 'easeInOut',
            delay: 0.5,
        },
    },
};
var PieSlice = function (_a) {
    var background = _a.background, draw = _a.draw, activePosition = _a.activePosition, autocolor = _a.autocolor, label = _a.label, startAngle = _a.startAngle, endAngle = _a.endAngle, labelPosition = _a.labelPosition, id = _a.id, activeKey = _a.activeKey, onMouseLeave = _a.onMouseLeave, onMouseMove = _a.onMouseMove, dataSeriesOffset = _a.dataSeriesOffset;
    var _b = __read(useState(false), 2), initialDrawFinished = _b[0], setInitialDraw = _b[1];
    var _c = __read(useState({
        startAngle: startAngle,
        endAngle: endAngle,
    }), 2), arcProperties = _c[0], setArcProperties = _c[1];
    var element = useRef(null);
    var theme = useContext(ChartContext).theme;
    var labels = theme.pie.labels;
    var _d = __read(activePosition, 2), x = _d[0], y = _d[1];
    var _e = __read(labelPosition, 2), labelX = _e[0], labelY = _e[1];
    var _f = __read(useState(false), 2), isDelayed = _f[0], setDelay = _f[1];
    var _g = __read(useState(false), 2), isActive = _g[0], setActive = _g[1];
    var activeControls = useAnimation();
    var activeVariants = getActiveKeyVariants(x, y);
    useEffect(function () {
        if (initialDrawFinished) {
            var motion_1 = createArcTween(arcProperties, { startAngle: startAngle, endAngle: endAngle }, draw);
            requestAnimationFrame(function () {
                animateArcPath(element, motion_1, function () {
                    setArcProperties({
                        startAngle: startAngle,
                        endAngle: endAngle,
                    });
                });
            });
            setDelay(true);
        }
    }, [startAngle, endAngle]);
    useEffect(function () {
        if (activeKey) {
            activeControls
                .start(activeKey === id ? activeVariants.active : activeVariants.inactive)
                .then(function () {
                setInitialDraw(true);
            });
        }
        else {
            activeControls
                .start(activeVariants.default, { delay: isDelayed ? 0.5 : 0 })
                .then(function () {
                if (isDelayed) {
                    setDelay(false);
                }
            });
        }
    }, [activeKey, background]);
    useEffect(function () {
        activeControls.start(activeVariants.offsetChange);
    }, [dataSeriesOffset]);
    return (React.createElement(motion.g, { "data-testid": id, variants: sliceVariants, initial: "hidden", animate: "show", exit: "remove" },
        React.createElement(motion.g, { key: "slice-" + background, onMouseMove: onMouseMove, onMouseEnter: function () { return setActive(true); }, onMouseLeave: function (e) {
                onMouseLeave(e);
                setActive(false);
            }, variants: activeVariants, animate: activeControls, initial: activeVariants.initial, whileHover: activeVariants.active, style: { originX: '0', originY: '0' }, transition: sliceTransition },
            React.createElement(StyledPath, { dropShadow: isActive, ref: element, d: draw(arcProperties), key: background, fill: background }),
            labels.enabled && (React.createElement(motion.g, { initial: false, animate: { x: labelX, y: labelY }, transition: { duration: 0.5, ease: 'easeInOut' } },
                React.createElement(PieLabel, __assign({ sliceBackground: background, autocolor: autocolor }, labels.typography), label))))));
};
export default PieSlice;
